<template>
  <div>
  </div>
</template>

<script>
import { trackUserAgent } from '@/api/trackevents';

export default {
  name: 'TrackEvents',
  props: {
    authToken: {
      type: String,
    },
    userId: {
      type: Number,
    },
    brandId: {
      type: String,
    },
    brandName: {
      type: String,
    },
  },
  watch: {
    authToken() {
      if (this.authToken !== '' && navigator.userAgent) {
        console.log('track useragent directly here');
        trackUserAgent(navigator.userAgent, this.authToken, this.brandName).then((result) => {
          console.log('We have tracked UserAgent', result);
        }).catch((err) => {
          console.log('error tracking UserAgent', err);
        });
      }
    },
  },
};
</script>

<style>

</style>
